import { API_CODE } from 'msal/lib-commonjs/telemetry/ApiEvent';

const OktaAuth = require('@okta/okta-auth-js').OktaAuth;

var oktaSession = null;

var authClient = new OktaAuth({
    issuer: GlobalIrisInitProps.tenantId,
    clientId: GlobalIrisInitProps.clientId,
    scopes: ['openid', 'email', 'profile'],
    redirectUri: GlobalIrisInitProps.logoutURL,
    pkce: true,
    responseType: ['token', 'id_token'],
    responseMode: "fragment",
    prompt: "none",
    // Configure TokenManager to use sessionStorage instead of localStorage
    tokenManager: {
        storage: 'sessionStorage'
    },
    postLogoutRedirectUri: GlobalIrisInitProps.logoutURL
})

export default {

    //loginWithRedirection() {
    //    return authClient.token.getWithRedirect({
    //        responseType: ['token', 'id_token'],
    //    })
    //    .catch(function (err) {
    //        // handle AuthSdkError (AuthSdkError will be thrown if app is in OAuthCallback state)
    //    });
    //},

    async isSessionOpened() {
        return authClient.session.exists()
            .then(function (exists) {
                if (exists) {
                    return true
                } else {
                    return false;
                }
            });
    },


    async getCurrentSession() {
        return authClient.session.get()
            .then(function (session) {
                oktaSession = session;
                return oktaSession;
            })
            .catch(function (err) {
                console.log(err);
            });
    },


    async login(email, pass, cb) {

        if (authClient.isLoginRedirect()) {
            // Parse token from redirect url
            return authClient.token.parseFromUrl()
                .then(data => {
                    let token = data.tokens.idToken;
                    console.log(`Hi isLoginRedirect ${token.claims.email}!`);
                    // Store parsed token in Token Manager
                    authClient.tokenManager.add('idToken', token);
                });
        } else {
            // Attempt to retrieve ID Token from Token Manager
            return authClient.tokenManager.get('idToken')
                .then(idToken => {
                    console.log(idToken);
                    if (idToken) {
                        console.log(`Hi getTokenId ${idToken.claims.email}!`);
                    }
                    else {
                        authClient.token.getWithRedirect({
                            //sessionToken: transaction.sessionToken,
                            responseType: 'id_token'
                        })
                        .catch(function (err) {
                            // handle AuthSdkError (AuthSdkError will be thrown if app is in OAuthCallback state)
                            console.log("Error getWithRedirect");
                        });
                    }
                });
        }
    },

    async getTokenFromSession() {

        if (authClient.isLoginRedirect()) {
            // Parse token from redirect url
            return authClient.token.parseFromUrl()
                .then(data => {
                    let token = data.tokens.idToken;
                    console.log(`Hi ${token.claims.email}!`);
                    // Store parsed token in Token Manager
                    authClient.tokenManager.add('idToken', token);
                    console.log(token);
                    return token;
                });
        }
        else {
            // Attempt to retrieve ID Token from Token Manager
            return authClient.tokenManager.get('idToken')
                .then(idToken => {
                    console.log(idToken);
                    if (idToken) {
                        console.log(`Hi ${idToken.claims.email}!`);
                        return idToken;
                    }
                    else {
                        authClient.signInWithRedirect({
                            scopes: [
                                'openid',
                                'email',
                                'profile',
                                'offline_access',
                            ],
                        });
                    }
                });
        }
    },

    setToken(token) {
        localStorage.idToken = token;
    },

    async getToken() {
        return authClient.tokenManager.get('idToken')
            .then(idToken => {
                if (idToken) {
                    return idToken;
                }
                else return null;
            });

    },

    logout(cb) {
        delete localStorage.token
        delete localStorage.idToken
        if (cb) cb()
        this.onChange(false)
        return authClient.signOut()
    },

    loggedIn() {
        return !!localStorage.token
    },

    onChange() {
    }
}